<template>
  <div class="resign-container">
    <img :src="imgUrl" class="resign-img"></img>
    <div class="resign-text">{{ resignText }}</div>
  </div>
</template>

<script>
import sucImg from '@/assets/img/icon_dingdan_sucess.png';
export default {
  name: 'resign',
  data() {
    return {
      imgUrl: sucImg,
      resignText: '重签成功'
    };
  },
  mounted() {
    window.document.title = '重新签署合同';
  }
};
</script>

<style scoped>
.resign-container {
  margin: 9 auto;
  text-align: center;
  padding-top: 360px;
}
.resign-img {
  width: 159px;
  height: 159px;
}
.resign-text {
  height: 38px;
  font-size: 40px;
  font-weight: bold;
  color: #06112a;
}
</style>


// WEBPACK FOOTER //
// src/view/resign.vue